module.exports = __webpack_public_path__ + "img/img06.1aad1c67.png";